function getId(obj) {
  if (obj) {
    return obj.id
  }
}

const infosGerais = () => ({
  idPropostaStatus: null,
  idTipoDeProposta:null,
  idPropostaTipo: null,
  idApoliceModalidade: null,
  idParcelamento: null,
  dataPrimeiraParcela: null,
  idFormaPagamento: null,
  proponenteRazaoSocial: null,
  proponenteCnpj: null,
  cepPernoite: null,
  idProponenteRamoDeAtuacao: null,
  enderecoCep: null,
  enderecoRua: null,
  enderecoNumero: null,
  enderecoComplemento: null,
  enderecoBairro: null,
  idEnderecoUf: null,
  enderecoCidade: null,
  enderecoTelefone: null,
  idTipoPessoa: null,
  enderecoEmail: null,
  apoliceIof: null,
  apolicePercSinistro: null,
  corretagem: null,
  dateInicio: null,
  dateFim: null,
  participanteList: null,
  percCondicaoComercial: null,
  idAplicaCondicao: null,
  idTipoCondicao: null,
  idUsuarioCorretor: null,
  nomeUsuarioCorretor: null,
  gatilhoEstipulado: null,
  sinistralidadePermissivel: null,
  informarNomeSocial: null,
  nomeSocial: null,
  idTecnicoResponsavel: null,
  nomeTecnicoResponsavel: null,
  listaCondicaoComercialEspecial: [],
  listaCondicaoComercialEspecialModificacao: [],
  tipoCalculo: 'NORMAL',
  valorPremioEstipulado: null
})

const riscos = () => ({
  idRiscoCargasEventuaisList: null,
  idRiscoFormaGerenciamentoList: null,
  idRiscoGerenciamento: null,
  idRiscoDirecaoDefensiva: null,
  idRiscoLimitadorVelocidade: null,
  idRiscoIdentificacaoVisual: null,
  idRiscoReclamacoes: null,
  idRiscoPermanenciaVeiculoForaList: null,
  idRiscoRegiaoCirculacaoList: null,
  idRiscoSegmentoAtuacaoList: null,
  idRiscoSegmentoEmbarcadorList: null,
  riscoSinistro: null,
  riscoBonsMotoristas: null,
  riscoMausMotoristas: null,
  riscoVeiculoFuncionario: null,
  riscoSeguroCarga: null,
  riscoTrafegamEstados: null,
  informacoesComplementares: null,
})

const totaisCotacao = () => ({
  totalAp: null,
  totalCoberturaCompensativa: null,
  totalCoberturaRcf: null,
  totalCoberturasAdicionais: null,
  totalFranquiaCoberturaAcessorios: null,
  totalFranquiaCoberturaCarroceria: null,
  totalFranquiaCoberturaCompensativa: null,
  totalFranquiaCoberturaEquipamentos: null,
  totalPremio: null,
  totalPremioLiquido: null,
  totalServicosAgregados: null,
})


const inicial = () => ({
  // planilha importada
  conteudoPlanilha: [],
  erroPlanilha: [],
  id: null,
  versao: null,
  apoliceNumeroProposta: null,
  apoliceNumero: null,

  ...infosGerais(),

  ...riscos(),

  ...totaisCotacao(),

})

const inicialModelReduzido = () => ({
  // planilha importada
  conteudoPlanilha: [],
  erroPlanilha: [],
  id: null,
  versao: null,
  apoliceNumeroProposta: null,
  apoliceNumero: null,

  ...riscos(),

  ...totaisCotacao(),

})

const state = {
  ...inicial(),
  copiaParcial: false
}

function aplicarDadosApolice(state, objetoDadosApolice) {
  Object.keys(inicial()).forEach(key => {
    state[key] = objetoDadosApolice[key];
  })
  Object.keys(totaisCotacao()).forEach(key => {
    state[key] = objetoDadosApolice.totaisCotacao[key];
  })
  state.conteudoPlanilha = objetoDadosApolice.itemCotacaoList;
  Object.keys(inicial()).filter(key => key.match(/^id[A-Z]/)).forEach(key => {
    const newKey = `${key.charAt(2).toLowerCase()}${key.slice(3)}`
    state[key] = key.match(/.*List$/) && objetoDadosApolice[newKey] instanceof Array ? objetoDadosApolice[newKey].map(item => getId(item)) : getId(objetoDadosApolice[newKey])
  })
}

const mutations = {
  setConteudoPlanilha(state, { dados }) {
    if (dados instanceof Array) {
      state.conteudoPlanilha = dados;
    }
  },

  setErroPlanilha(state, { dados }) {
    if (dados instanceof Array) {
      state.erroPlanilha = dados;
    }
  },

  setInfoGerais(state, objetoInfoGerais) {
    Object.keys(infosGerais()).forEach(key => {
      state[key] = objetoInfoGerais[key];
    })
  },

  setDadosPagamento(state, dados) {
    state.dataPrimeiraParcela = dados.dataPrimeiraParcela;
    state.idParcelamento = dados.idParcelamento;
    state.idFormaPagamento = dados.idFormaPagamento;
    state.apoliceIof = dados.apoliceIof;
    state.corretagem = dados.corretagem;
  },

  setCondicaoComercial(state, condicao) {
    state.idTipoCondicao = condicao.idTipoCondicao;
    state.idAplicaCondicao = condicao.idAplicaCondicao;
    state.percCondicaoComercial = condicao.percCondicaoComercial;
    state.listaCondicaoComercialEspecial = condicao.listaCondicaoComercialEspecial;
    state.listaCondicaoComercialEspecialModificacao = condicao.listaCondicaoComercialEspecialModificacao;
  },

  setRisco(state, objetoRisco) {
    Object.keys(riscos()).forEach(key => {
      state[key] = objetoRisco[key];
    })
  },

  limparTudo(state) {
    Object.entries(inicial()).forEach(([key, value]) => {
      state[key] = value;
    })
    state.copiaParcial = false;
  },

  setCopiaParcial(state, copiaParcial) {
    state.copiaParcial = !!copiaParcial;
  },

  setDadosApolice(state, objetoDadosApolice) {
    aplicarDadosApolice(state, objetoDadosApolice);
  },

  setDadosApoliceCopiaParcial(state, objetoDadosApolice) {
    const itens = state.conteudoPlanilha;
    const erros = state.erroPlanilha;
    aplicarDadosApolice(state, objetoDadosApolice);
    state.conteudoPlanilha = itens instanceof Array ? itens : [];
    state.erroPlanilha = erros instanceof Array ? erros : [];
  },
  setDadosApoliceReduzido(state, objetoDadosApolice) {
    Object.keys(inicialModelReduzido()).forEach(key => {
      state[key] = objetoDadosApolice[key];
    })
    Object.keys(totaisCotacao()).forEach(key => {
      state[key] = objetoDadosApolice.totaisCotacao[key];
    })
    state.conteudoPlanilha = objetoDadosApolice.itemCotacaoList;
    Object.keys(inicial()).filter(key => key.match(/^id[A-Z]/)).forEach(key => {
      const newKey = `${key.charAt(2).toLowerCase()}${key.slice(3)}`
      state[key] = key.match(/.*List$/) && objetoDadosApolice[newKey] instanceof Array ? objetoDadosApolice[newKey].map(item => getId(item)) : getId(objetoDadosApolice[newKey])
    })

  },

  setTipoCalculo(state, tipoCalculo) {
    state.tipoCalculo = tipoCalculo;
  },

  setValorPremioEstipulado(state, valor) {
    state.valorPremioEstipulado = valor;
  }
}

const getters = {
  conteudoPlanilhaValido(state) {
    return state.conteudoPlanilha instanceof Array && !!state.conteudoPlanilha.length
  },

  quantidadeItem(state) {
    return state.conteudoPlanilha.length
  },

  conteudoInfoGeraisValido(state, getters) {
    return getters.conteudoPlanilhaValido;
  },

  riscosPreenchidos(state) {
    return Object.keys(riscos()).filter((key) => key !== 'informacoesComplementares').every(key => (state[key] !== null && state[key] !== undefined) || (state[key] instanceof Array && state[key].length))
  },

  conteudoRiscosValido(state, getters) {
    return getters.conteudoInfoGeraisValido && getters.riscosPreenchidos
  },

  cloneConteudoPlanilha(state) {
    try {
      return JSON.parse(JSON.stringify(state.conteudoPlanilha))
    } catch (error) {
      return [];
    }
  },
  cloneErroPlanilha(state) {
    try {
      return JSON.parse(JSON.stringify(state.erroPlanilha))
    } catch (error) {
      return [];
    }
  },
  conteudoCalculoPlanilha(state) {
    return Object.fromEntries(Object.entries(state).filter(([nome]) => nome.match(/^((r|idR|idsR)isco.*|conteudoPlanilha|apoliceIof|corretagem|percCondicaoComercial|idAplicaCondicao|idTipoCondicao|tipoCalculo|valorPremioEstipulado)/)))
  },
  conteudoSalvarCotacao(state) {
    const { erroPlanilha, copiaParcial, ...cotacao } = state;
    return cotacao;
  },

  copiaParcial(state) {
    return state.copiaParcial === true;
  },

  copiaParcialSemItens(state, getters) {
    return state.copiaParcial === true && !getters.conteudoPlanilhaValido;
  },

  estadoWizard(state, getters) {
    return {
      conteudoPlanilhaValido: getters.conteudoPlanilhaValido,
      conteudoInfoGeraisValido: getters.conteudoInfoGeraisValido,
      conteudoRiscosValido: getters.conteudoRiscosValido,
      riscosPreenchidos: getters.riscosPreenchidos,
      copiaParcialSemItens: getters.copiaParcialSemItens
    };
  },

  infoGerais(state) {
    return { ...Object.fromEntries(Object.keys(infosGerais()).map(key => [key, state[key]])), totalPremio: state.totalPremio, apoliceNumero: state.apoliceNumero, apoliceNumeroProposta: state.apoliceNumeroProposta }
  },

  risco(state) {
    return Object.fromEntries(Object.keys(riscos()).map(key => [key, state[key]]))
  },
  totais(state) {
    return Object.fromEntries(Object.keys(totaisCotacao()).map(key => [key, state[key]]))
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/formCotacao.js